import PreviewSection from '../PreviewSection'

export default function CSVPreviewSection() {}

CSVPreviewSection.prototype = new PreviewSection();

CSVPreviewSection.prototype.init = function ()
{
    PreviewSection.prototype.init.call( this );
    return this;
};
CSVPreviewSection.prototype.addRow = function ( tBody, row )
{
    this._addRow(tBody, row, "rowHeader");
};

CSVPreviewSection.prototype.addRowWithAdditionalClass = function ( tBody, row, newClass )
{
    this._addRow(tBody, row, "rowHeader " + newClass);
};

CSVPreviewSection.prototype._addRow = function ( tBody, row, cellClass )
{
    let rowNum = tBody.childNodes.length
    row.insertBefore( ReportPreviewUtils.createCell( rowNum, cellClass ), row.firstChild );
    PreviewSection.prototype.addRow.call( this, tBody, row );
};

CSVPreviewSection.prototype.addCellWithFloatingContent = function( row, notEscapedContent )
{
    ReportPreviewUtils.addCellWithFloatingContent( row, notEscapedContent );
};

CSVPreviewSection.prototype.addValueCell = function ( row, innerHTML )
{
    this.addCell(row, innerHTML, "value");
};

CSVPreviewSection.prototype.addTimeValueCell = function ( row )
{
    this.addValueCell(row, ReportPreviewUtils.getCSVTimeValue());
};





// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/CSVPreviewSection.js